import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import { Widget } from "./Widget"
import React, { useState, useEffect } from "react";

export const WidgetComprasDelDia = ({ Fecha, WidgetKey }) => {
  const [loading, setLoading] = useState(true)
  const [data, setData] = useState([])
  const { Varios: { FormateoFechaPara_yyyyMMdd } } = require('neftis7_apicaller');
  const { COM_DocsCompra_Cabecera: { function_COM_DocsCompra_Cabecera_ComparacionADiaAnterior } } = require('neftis7_apicaller');

  const getData = async () => {
    // Llama a función asíncrona y maneja los datos
    try {
      const resultData = await function_COM_DocsCompra_Cabecera_ComparacionADiaAnterior(await FormateoFechaPara_yyyyMMdd(Fecha));
      setData(resultData.data || [])
    } catch (error) {
      alert("Error al obtener los datos: " + error);
    }
    setLoading(false)
  };

  useEffect(() => {
    getData();
  }, [Fecha, WidgetKey]);

  const data0 = data?.[0] || {}; // backup por si no hay data[0]
  const dataFinal = {
    title: "COMPRAS DEL DÍA",
    MuestraMonto: true,
    tituloLink: "Ver Compras",
    link: "COM_DocsCompra_",
    Monto: data0.MontoTotal != null ? data0.MontoTotal.toLocaleString('es-ES') : "0",
    Cantidad: data0.CantidadRegistros != null ? data0.CantidadRegistros : 0,
    PorcentajeMonto: data0.PorcentajeMontoTotalSobreDiaAnterior ?? 0,
    PorcentajeCantidad: data0.PorcentajeCantidadSobreDiaAnterior ?? 0,
    icon: (
      <ShoppingCartOutlinedIcon
        className="icon"
        style={{
          backgroundColor: "lightpink",
          color: "red",
          width: "30px",
          height: "30px",
          margin: "0px 15px 0px 0px "
        }}
      />
    ),
  };

  return (
    <div>
      {data && data.length > 0 && (
        <Widget
          titulo={dataFinal.title}
          esMoneda={dataFinal.MuestraMonto}
          link={dataFinal.link}
          tituloLink={dataFinal.tituloLink}
          icono={dataFinal.icon}
          Monto={dataFinal.Monto}
          Cantidad={dataFinal.Cantidad}
          PorcentajeMonto={dataFinal.PorcentajeMonto}
          PorcentajeCantidad={dataFinal.PorcentajeCantidad}
        />
      )}
    </div>
  );
};
